/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Marin GET /courses/products/printoffer/:productId
 *
 * @file PrintOfferService.js
 * @author Mohamed yasar arabath M
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  PRINT_OFFER_REQUESTED,
  PRINT_OFFER_COMPLETED,
  PRINT_OFFER_FAILED
} from '../../../common/constants';

export default class PrintOfferService extends BaseService {
  constructor() {
    super(PRINT_OFFER_REQUESTED);
  }

  /**
   * GET /courses/products/printoffer/:productId
   *
   * @param {string} productId - Product identifier
   * @returns {Promise}
   */
  fetch(productId) {
    return this.getClient('marin').get(`/courses/products/printoffer/${productId}`);
  }

  handleEvent(eventName, eventData = {}) {
    const { productId } = eventData;

    if (!productId) {
      return Promise.reject(new Error('PrintOfferService: productId is required'));
    }

    return this.fetch(productId);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    const { data } = response;
    const { callback } = eventData;

    Framework.getEventManager().publish(PRINT_OFFER_COMPLETED, data);

    if (typeof callback === 'function') {
      callback(data);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error, eventData = {}) {
    const { callback } = eventData;

    Framework.getEventManager().publish(PRINT_OFFER_FAILED, error);

    if (typeof callback === 'function') {
      callback(null, error);
    }
  }
}
